import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';

import Card from './Card';
import Divider from 'components/ui/Divider';
import StatusTag from 'components/ui/StatusTag';
import CheckboxNormal from 'components/ui/CheckboxNormal';
import Loading from 'components/ui/Animations/Loading';
import TextButton from 'components/ui/Buttons/TextButton';

import './checkbox-style.css';

const MarginBottom = styled.div`
  margin-bottom: 8px;
`;

const StyledBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 90px;
`;

const StyledActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledTitleText = styled.p`
  font-size: 18px;
  margin: 0;
  color: ${colors.MED_DARK_GRAY};
`;

const StyledDetailText = styled.p`
  font-size: 12px;
  margin: 0;
  color: ${colors.SLATE_GREY};
`;

const StyledDivider = styled(Divider)`
  margin-top: 15px;
  margin-bottom: 15px;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.06);
`;

const StyledApplicantDetails = styled.div`
  align-self: start;
`;

const StyledCheckBoxContainer = styled.div`
  align-self: center;
`;

const StyledApplicantCard = styled.div`
  cursor: pointer;
`;

const ApplicantCard = ({
  status,
  fullName,
  email,
  phoneNumber,
  isSelectable,
  isChecked,
  handleSelect,
  primaryAction,
  primaryActionText,
  secondaryAction,
  secondaryActionText,
}) => {
  const [primaryActionIsLoading, setPrimaryActionIsLoading] = useState(false);
  const [secondaryActionIsLoading, setSecondaryActionIsLoading] = useState(false);

  const showBottomActions = () => {
    return (primaryAction && primaryActionText) || (secondaryAction && secondaryActionText);
  };

  const handleClick = e => {
    // Clicking either the checkbox or anywhere on the card
    if (isSelectable && handleSelect) {
      if (e.target.checked !== undefined) {
        return handleSelect(e.target.checked);
      } else {
        return handleSelect(!isChecked);
      }
    }
  };

  const handlePrimaryAction = async () => {
    setPrimaryActionIsLoading(true);
    await primaryAction();
    setPrimaryActionIsLoading(false);
  };

  const handleSecondaryAction = async () => {
    setSecondaryActionIsLoading(true);
    await secondaryAction();
    setSecondaryActionIsLoading(false);
  };

  return (
    <StyledApplicantCard onClick={handleClick}>
      <Card>
        <StyledBody>
          <StyledApplicantDetails>
            {status && (
              <MarginBottom>
                <StatusTag status={status} />
              </MarginBottom>
            )}
            <MarginBottom>
              <StyledTitleText>{fullName}</StyledTitleText>
            </MarginBottom>
            <StyledDetailText>{email}</StyledDetailText>
            <StyledDetailText>{phoneNumber}</StyledDetailText>
          </StyledApplicantDetails>
          <StyledCheckBoxContainer>
            {isSelectable && (
              <CheckboxNormal
                style={{ marginTop: '17.5px' }}
                checked={isChecked}
                accentColor={colors.DEEP_BLUE}
              />
            )}
          </StyledCheckBoxContainer>
        </StyledBody>
        {showBottomActions() && (
          <React.Fragment>
            <StyledDivider />
            <StyledActionsContainer>
              {primaryAction &&
                (primaryActionIsLoading ? (
                  <Loading width={25} height={25} style={{ margin: '-5px 8px 0 0' }} />
                ) : (
                  <TextButton onClick={handlePrimaryAction} disabled={secondaryActionIsLoading}>
                    {primaryActionText}
                  </TextButton>
                ))}
              {secondaryAction &&
                (secondaryActionIsLoading ? (
                  <Loading width={25} height={25} style={{ margin: '-5px 8px 0 0' }} />
                ) : (
                  <TextButton onClick={handleSecondaryAction} disabled={primaryActionIsLoading}>
                    {secondaryActionText}
                  </TextButton>
                ))}
            </StyledActionsContainer>
          </React.Fragment>
        )}
      </Card>
    </StyledApplicantCard>
  );
};

export default ApplicantCard;
